var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLabourRoute
    ? _c("app-side-menu", [
        _c(
          "aside",
          {
            staticClass: "menu",
            attrs: { slot: "side-menu" },
            slot: "side-menu",
          },
          [
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Labour Times")]),
              _c(
                "div",
                {
                  class: { tooltip: _vm.hasNtarLtarItems },
                  attrs: {
                    "data-tooltip": [
                      _vm.hasNtarLtarItems ? "NTAR or LTAR items exist" : "",
                    ],
                  },
                },
                [
                  _c("div", { staticClass: "select is-fullwidth" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.innerTemplateTimesType,
                            expression: "innerTemplateTimesType",
                          },
                        ],
                        attrs: { disabled: _vm.hasNtarLtarItems },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.innerTemplateTimesType = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "null", disabled: "" } },
                          [_vm._v("Select")]
                        ),
                        _vm._l(
                          _vm.labourTimesTypes,
                          function (labourTimesType, index) {
                            return _c("option", { key: index }, [
                              _vm._v(" " + _vm._s(labourTimesType) + " "),
                            ])
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Vehicle Body Style"),
              ]),
              _c(
                "div",
                {
                  class: { tooltip: _vm.innerTemplateBodyId && _vm.hasItems },
                  attrs: {
                    "data-tooltip": [
                      _vm.innerTemplateBodyId && _vm.hasItems
                        ? "Switch after removing all labour items"
                        : "",
                    ],
                  },
                },
                [
                  _c("div", { staticClass: "select is-fullwidth" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.innerTemplateBodyId,
                            expression: "innerTemplateBodyId",
                          },
                        ],
                        attrs: {
                          disabled: _vm.innerTemplateBodyId && _vm.hasItems,
                        },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.innerTemplateBodyId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "null", disabled: "" } },
                          [_vm._v("Select")]
                        ),
                        _vm._l(_vm.bodyStyles, function (style, index) {
                          return _c(
                            "option",
                            { key: index, domProps: { value: style.id } },
                            [_vm._v(" " + _vm._s(style.name) + " ")]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }